<div class="menu d-flex align-items-center fs-12 fw-500 font-secondary fs-12 lh-1">
    @for (language of languages; track language; let last = $last) {
        <a href="/{{ language }}" [class.active]="currentLang === language" translate>LANG.{{ language }}</a>
        @if (!last) {
            <span class="mx-2 text-gray-300"> | </span>
        }
    }

    <a [href]="appUrl" target="_blank" class="d-flex align-items-center btn p-0 ms-md-12 ms-auto icon-app">
        <span class="login-text">
            {{ 'login' | translate }}
        </span>
        <div class="icon icon-xxxl">
            <svg
                aria-hidden="true"
                focusable="false"
                data-icon="door-icon"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 494.239 494.238"
            >
                <g>
                    <path
                        d="M199.725,0v36.025H85.211v421.66l114.514,0.094v36.459l209.085-37.555l0.216-418.867L199.725,0z M234.404,230.574c7.022,0,12.715,7.408,12.715,16.545c0,9.139-5.692,16.545-12.715,16.545s-12.715-7.406-12.715-16.545C221.688,237.982,227.382,230.574,234.404,230.574z M119.211,423.713V70.025h80.514v353.753L119.211,423.713z"
                    />
                </g>
            </svg>
        </div>
    </a>
</div>
